import React, { useRef, useState } from 'react'
import { useDebounceFn } from 'ahooks'
import ResizeObserver from 'rc-resize-observer'
import { Column } from '@/components/layout/layout'

// 用户存放工具组件 如滚动加载，自动填充高度等
interface WithScrollLoadProps {
    scrollloadhandle: {
        loadMore: () => void
        loadingMore: boolean
    }
    bottomtip?: React.ReactNode
}

type Iprops = WithScrollLoadProps &
    Partial<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>>

export const WithScrollLoad: React.FC<Iprops> = props => {
    const lastScrollTop = useRef<number>(0)
    const { run: loadMoreDebounce } = useDebounceFn(
        () => {
            if (props.scrollloadhandle.loadingMore) return
            props.scrollloadhandle.loadMore()
        },
        {
            wait: 100,
        },
    )

    const scrollNode = (
        <div
            {...props}
            onScrollCapture={e => {
                if (
                    (e.target as HTMLElement).scrollTop - lastScrollTop.current > 30 &&
                    (e.target as HTMLElement).scrollHeight -
                        (e.target as HTMLElement).scrollTop -
                        (e.target as HTMLElement).clientHeight <=
                        50
                ) {
                    loadMoreDebounce()
                }
            }}
        >
            {props.children}
        </div>
    )

    return props.bottomtip ? (
        <Column>
            {scrollNode}
            {props.bottomtip}
        </Column>
    ) : (
        scrollNode
    )
}

export const AutoResizer: React.FC<{
    children: (options: { width: number; height: number }) => React.ReactNode
}> = props => {
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)

    return (
        <ResizeObserver
            onResize={e => {
                setWidth(e.width)
                setHeight(e.height)
            }}
        >
            {props.children({ width, height })}
        </ResizeObserver>
    )
}

export function isNoMore(data: any) {
    if (data && data.pagination) {
        return data.pagination.page === data.pagination.page_count
    } else {
        return false
    }
}
